import React, { Component } from 'react';
import ReactExport from "react-export-excel-xlsx-fix";
import { Download, ImportExport } from "@mui/icons-material";
import moment from "moment";
import Global from "../../customlib/Global";
import { Button } from '@mui/material';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const dataSet1 = [
    {
        name: "Johson",
        amount: 30000,
        sex: 'M',
        is_married: true
    },
    {
        name: "Monika",
        amount: 355000,
        sex: 'F',
        is_married: false
    },
    {
        name: "John",
        amount: 250000,
        sex: 'M',
        is_married: false
    },
    {
        name: "Josef",
        amount: 450500,
        sex: 'M',
        is_married: true
    }
];

var dataSet2 = [
    {
        name: "Johnson",
        total: 25,
        remainig: 16
    },
    {
        name: "Josef",
        total: 25,
        remainig: 7
    }
];

class ExportAgentsPerforma extends Component {

    getAgentsPerformaData = () => {
        let leadsData = [];
        this.props.agentsPerformaData.forEach(element => {
            element.leadsCount = element.leads?.length;
            leadsData.push(element);
        });
        return leadsData;
    }

    state = {  }
    render() { 
        return (
            <ExcelFile element={<Button size='small' variant='outlined' color='default' sx={{textTransform: "capitalize"}}><Download />Export</Button>}>

                <ExcelSheet data={this.getAgentsPerformaData} name="Agents Performa Report">
                    <ExcelColumn label="Agent" value="agentName"/>
                    <ExcelColumn label="Score" value="scoreAgent"/>
                    <ExcelColumn label="SLA (First Response)" value="slaPercentage"/>
                    <ExcelColumn label="Follow Up (Compliance)" value="followupCompliancePercentage"/>
                    <ExcelColumn label="AI Suggestion (Usage)" value="leadsUsingAiPercentage"/>
                    <ExcelColumn label="Alignment (Guidance)" value="alignmentGuidancePercentage"/>
                    <ExcelColumn label="Leads (Ditangani)" value="leadsCount"/>
                    <ExcelColumn label="Red Flag" value="redFlagCount"/>
                </ExcelSheet>
            </ExcelFile>
        );
    }
}
 
export default ExportAgentsPerforma;